import { useState } from 'react'

import { LIVE_SITE_URL } from '@constants'
import ApplyStepIcon from 'components/ApplyStepIcon'
import ApplyStepButtons from 'components/ApplyStepButtons'

import s from './ApplyFormConsent.module.css'
import isModellinkSite from '../../../helpers/isModellinkSite'
import * as Sentry from '@sentry/nextjs'

//TODO: setup proptypes
function ApplyFormConsent({ onSubmit, goBack, initialValues }) {
  const [errors, setErrors] = useState([])
  const [fieldValues, setFieldValues] = useState({
    consent: false,
    termsAgreed: false,
    newsletter: false,
  })

  const handleAttrChange = (attr, val) => {
    const fields = { ...fieldValues }
    fields[attr] = val
    setFieldValues(fields)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = []
    if (!fieldValues.consent) newErrors.push('consent')
    if (!fieldValues.termsAgreed) newErrors.push('termsAgreed')
    if (newErrors.length) {
      setErrors(newErrors)
    } else {

      const submitValues = {...fieldValues}

      Sentry.addBreadcrumb({
        category: 'form',
        message: 'Consent Submitted',
        level: 'debug',
        data: submitValues,
      })

      onSubmit(submitValues)
    }
  }

  const businessName = isModellinkSite() ? 'Modellink' : 'Select Models'

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Consent</h1>
        <p className={s.text}>
          Please provide consent that you are happy for us to hold your data so
          we can process your application.
        </p>
        <div className={s.columns}>
          <div className={s.column}>
            <p className={s.consentText}>
              By submitting this form you give consent to {businessName} to
              process your data to evaluate the potential of becoming a model,
              and agree for a member from {businessName} to contact you if
              successful. Your application will be stored for 30 days. If you do
              not hear from us within this time frame then unfortunately your
              application has been unsuccessful on this occasion.
            </p>
            <div className={s.field}>
              {errors && errors.includes('consent') && (
                <p className={s.checkboxError}>
                  Consent must be granted to continue
                </p>
              )}
              <label className={s.checkboxLabel} htmlFor='consent'>
                <input
                  type='checkbox'
                  id='consent'
                  name='consent'
                  onChange={(e) =>
                    handleAttrChange('consent', e.target.checked)
                  }
                  className={s.checkbox}
                />
                <span className={s.checkboxIcon} />I agree
              </label>
            </div>
          </div>
          <div className={s.column}>
            <p className={s.consentText}>
              By submitting this form you agree with our{' '}
              <a href={`${LIVE_SITE_URL}/${initialValues.office}/terms`}>
                Privacy Policy
              </a>{' '}
              &{' '}
              <a href={`${LIVE_SITE_URL}/${initialValues.office}/terms`}>
                Terms of Use
              </a>
              .
            </p>
            <div className={s.field}>
              {errors && errors.includes('termsAgreed') && (
                <p className={s.checkboxError}>
                  Terms of use must be agreed to continue
                </p>
              )}
              <label className={s.checkboxLabel} htmlFor='termsAgreed'>
                <input
                  type='checkbox'
                  id='termsAgreed'
                  name='termsAgreed'
                  onChange={(e) =>
                    handleAttrChange('termsAgreed', e.target.checked)
                  }
                  className={s.checkbox}
                />
                <span className={s.checkboxIcon} />I agree
              </label>
            </div>
            <p className={s.consentText}>
              Tick to sign up to the {businessName} database where you will
              receive updates & newsletters.
            </p>
            <div className={s.field}>
              <label className={s.checkboxLabel} htmlFor='newsletter'>
                <input
                  type='checkbox'
                  id='newsletter'
                  name='newsletter'
                  onChange={(e) =>
                    handleAttrChange('newsletter', e.target.checked)
                  }
                  className={s.checkbox}
                />
                <span className={s.checkboxIcon} />I agree
              </label>
            </div>
          </div>
        </div>
        <ApplyStepButtons back={goBack} />
      </form>
      <ApplyStepIcon step='consent' />
    </div>
  )
}

export default ApplyFormConsent
